var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnGoingCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.969,
    height: 11.607,
    viewBox: "0 0 23.969 11.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".avideo{fill:none;stroke-width:1px;}.avideo,.bvideo{stroke:#47c06a;}.bvideo12{fill:#47c06a;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-177.601 -193.641)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 34)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "avideo",
    y1: 2.387,
    x2: 2.387,
    transform: "translate(194.382 163.5) rotate(45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "avideo",
    y1: 2.387,
    x2: 2.387,
    transform: "translate(194.575 162.382) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "avideo",
    y1: 2.387,
    x2: 2.387,
    transform: "translate(194.575 167.995) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-139 52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bvideo12",
    d: "M337.893,170H326.729a1.389,1.389,0,0,0-1.4,1.384v8.3a1.389,1.389,0,0,0,1.4,1.384h11.164a1.389,1.389,0,0,0,1.4-1.384v-8.3A1.389,1.389,0,0,0,337.893,170Z",
    transform: "translate(-8.582 -27.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bvideo12",
    d: "M341.992,170.779a.692.692,0,0,0-.443.162l-3.042,2.514v4.151l3.042,2.514a.7.7,0,0,0,1.144-.531v-8.116A.7.7,0,0,0,341.992,170.779Z",
    transform: "translate(-8.498 -27.966)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnGoingCall);
export default __webpack_public_path__ + "static/media/onGoingCall.81e6b704494d5182df1568671e0052ac.svg";
export { ForwardRef as ReactComponent };